import React from 'react';
import BlurFade from '../primitives/BlurFade';
import { Section } from '../layout/Section';
import { Container } from '../layout/Container';
import { Eyebrow, Headline, Body } from '../layout/typography';
import Pill from '../ui/Pill';
import { useLang } from '../../LangContext';
import { mediaAlt } from '../../lib/mediaSeo';

/**
 * SamplePromoBlock — micro-conversion CTA (e.g. "Gratis adviesgesprek").
 * Bright card with a single low-commitment ask. Inspired by clip-shade's
 * "Gratis Stoffmuster" approach.
 */
export default function SamplePromoBlock({
  id, testId, tone = 'cream', rhythm = 'relaxed',
  eyebrow, title, body, mediaSrc, ctas = [],
}) {
  const { lang, overlay } = useLang();
  return (
    <Section id={id} data-testid={testId} tone={tone} rhythm={rhythm}>
      <Container>
        <div className="relative overflow-hidden rounded-[24px] border border-[#F26B1A]/15 bg-gradient-to-br from-[#FAF8F2] via-[#F6EFD8] to-[#E8F0E5] p-8 lg:p-14">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-10 lg:gap-x-12 items-center">
            <div className="lg:col-span-7 lg:col-start-1">
              {eyebrow && <BlurFade><Eyebrow className="mb-6">{eyebrow}</Eyebrow></BlurFade>}
              {title && <BlurFade delay={0.05}><Headline size="md">{title}</Headline></BlurFade>}
              {body && <BlurFade delay={0.1}><Body className="mt-5 max-w-md">{body}</Body></BlurFade>}
              {ctas.length > 0 && (
                <BlurFade delay={0.2} className="mt-8 flex flex-col sm:flex-row gap-3">
                  {ctas.map((c, i) => (
                    <Pill key={c.testId || `${c.kind}-${c.label}`} variant={c.variant || (i === 0 ? 'leaf' : 'outline')}
                          icon={c.kind === 'whatsapp' ? 'whatsapp' : c.kind === 'phone' ? 'phone' : 'arrow'}
                          iconLeft={c.kind !== 'primary'}
                          href={c.href} testId={c.testId} source={c.source}
                          {...(c.kind === 'whatsapp' ? { target: '_blank', rel: 'noreferrer' } : {})}>
                      {c.label}
                    </Pill>
                  ))}
                </BlurFade>
              )}
            </div>
            {mediaSrc && (
              <BlurFade className="lg:col-span-5 lg:col-start-8" delay={0.15} offset={14}>
                <div className="relative rounded-[16px] overflow-hidden aspect-[4/3] bg-white">
                  <img src={mediaSrc} alt={mediaAlt(overlay, mediaSrc, lang, title || eyebrow || '')} className="absolute inset-0 w-full h-full object-cover" />
                </div>
              </BlurFade>
            )}
          </div>
        </div>
      </Container>
    </Section>
  );
}
